import { Component, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsValidators } from '../../components/forms/validators/forms.validators';
import { AffordabilityService } from '../../services/affordability.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  templateUrl: 'personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  imports: [NgTemplateOutlet, FormsModule, ReactiveFormsModule],
})
export class PersonalDetailsComponent implements OnInit {
  private readonly modalService = inject(NgbActiveModal);
  private readonly affordabilityService = inject(AffordabilityService);

  @ViewChild('modalBody', { read: ViewContainerRef }) public modalBody;
  public applicantFormGroups: UntypedFormGroup[] = [];
  public fewApplicants: boolean;
  public applicantsCount: number;
  private readonly content: any;

  public ngOnInit(): void {
    this.applicantsCount = this.content?.applicantsCount ?? 1;
    this.fewApplicants = this.applicantsCount > 1;

    for (let i = 0; i < this.applicantsCount; i++) {
      this.applicantFormGroups.push(
        new UntypedFormGroup({
          firstName: new FormControl('', Validators.required),
          lastName: new FormControl('', Validators.required),
          emailAddress: new FormControl('', FormsValidators.email),
          phoneNumber: new FormControl('', [
            Validators.required,
            FormsValidators.telephone,
            FormsValidators.minLength(6),
            FormsValidators.maxLength(15),
          ]),
          postCode: new FormControl('', FormsValidators.postcode),
        }),
      );
    }
  }

  public isControlInvalid(controlName: string, formGroup: UntypedFormGroup): boolean {
    const control = formGroup.controls[controlName];
    return control.touched && control.invalid;
  }

  public isControlValid(controlName: string, formGroup: UntypedFormGroup): boolean {
    const control = formGroup.controls[controlName];
    return control.touched && control.valid && control.value;
  }

  public isControlEmpty(controlName: string, formGroup: UntypedFormGroup): boolean {
    return formGroup.controls[controlName]?.errors?.required;
  }

  public get isApplicantsValid() {
    return this.applicantFormGroups.every((formGroup) => formGroup.valid);
  }

  public submit(): void {
    if (!this.isApplicantsValid) {
      this.applicantFormGroups.forEach((fg) => fg.markAllAsTouched());
      this.scrollToFirstError();
      return;
    }
    this.affordabilityService.customers = this.applicantFormGroups.map((app) => app.value);
    this.affordabilityService.isSendEmail = true;
    this.modalService.close();
  }

  public closeModal(): void {
    this.modalService.dismiss();
  }

  private scrollToFirstError(): void {
    setTimeout(() => {
      const invalidInput = this.modalBody.element.nativeElement.querySelector('.is-invalid');
      if (invalidInput) {
        invalidInput.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, 200);
  }
}
